import { render, staticRenderFns } from "./qs1-09.vue?vue&type=template&id=8b5bf202&scoped=true&"
import script from "./qs1-09.vue?vue&type=script&lang=js&"
export * from "./qs1-09.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5bf202",
  null
  
)

export default component.exports